// Implements: F-GEN-007, F-UIX-010
/**
 * A pause that an abort cuts short.
 *
 * It resolves (never rejects) either when `ms` elapse or when `signal` aborts,
 * and in the first case it takes its `abort` listener off the signal: a signal
 * that lives as long as a generation would otherwise collect one listener per
 * pause.
 */
export function abortableDelay(ms: number, signal: AbortSignal): Promise<void> {
  return new Promise((resolve) => {
    const onAbort = (): void => {
      clearTimeout(timer);
      resolve();
    };
    const timer = setTimeout(() => {
      signal.removeEventListener("abort", onAbort);
      resolve();
    }, ms);
    signal.addEventListener("abort", onAbort, { once: true });
  });
}
